export interface CompanyAddress {
  city: string;
  state: string;
}

export interface CompanyContact {
  phone1: string;
  phone2?: string;
  email: string;
}

export interface CompanyInfo {
  name: string;
  legalName: string;
  url: string;
  tagline: string;
  description: string;
  vision: string;
  address: CompanyAddress;
  contact: CompanyContact;
  socialMedia: {
    linkedin: string;
    twitter: string;
  };
}

export const companyInfo: CompanyInfo = {
  name: 'NEAT Systems',
  legalName: 'NEAT Systems Pvt Ltd',
  url: 'https://www.neat-systems.com',
  tagline: 'Building Smarter IT Infrastructure',
  description:
    'Your strategic partner for enterprise-grade computing and networking solutions. Delivering cutting-edge technology from HP, Dell, Lenovo, Supermicro, Cisco, Arista, and Juniper.',
  vision:
    'To be the premier technology partner that empowers organizations to achieve operational excellence through innovative IT infrastructure solutions.',
  address: {
    city: 'Mumbai',
    state: 'Maharashtra',
  },
  contact: {
    phone1: '+91-9820280024',
    email: 'contact@neat-systems.com',
  },
  socialMedia: {
    linkedin: 'https://linkedin.com/company/neat-systems',
    twitter: 'https://twitter.com/neatsystems',
  },
};
